import { render, staticRenderFns } from "./WhdHomepage.vue?vue&type=template&id=e23b5e68&lang=pug&"
import script from "./WhdHomepage.vue?vue&type=script&lang=js&"
export * from "./WhdHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports